/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum EntityBranchActionEnum {
    ADD = 'Add',
    CUT = 'Cut'
}
